import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

import {BusinessUnit, ReviewsResponse} from './trustPilot.types'

export const trustPilotApi = createApi({
  reducerPath: 'trustPilotApi',
  baseQuery: fetchBaseQuery({baseUrl: '/api/trustpilot'}),
  endpoints: builder => ({
    getBusinessUnit: builder.query<BusinessUnit, void>({
      query: () => `/details`
    }),
    getReviews: builder.query<
      ReviewsResponse,
      {
        stars: number
        language: string
        perPage?: number
        page?: number
        orderBy?: string
      }
    >({
      query: ({
        stars,
        language,
        perPage,
        page,
        orderBy = 'createdat.desc'
      }) => ({
        url: `/reviews`,
        params: {stars, language, perPage, page, orderBy}
      })
    })
  })
})

export const {useGetBusinessUnitQuery, useGetReviewsQuery} = trustPilotApi
